// import i18n from '../i18n.js'
import { createApp } from 'vue';
import { createPinia } from 'pinia'
import ElementPlusEn from 'element-plus/es/locale/lang/en';
import { useDonationFormsStore } from './store'
// import store from './store'
// import donation_mixin from './mixin'

import Modal from './components/Modal.vue';
import RecurringCycle from "./components/RecurringCycle.vue";
import PageTemplate from './components/PageTemplate.vue';
import Button from './components/Button.vue';
import AmountBox from './components/AmountBox.vue';
import ProceedBtn from './components/ProceedBtn.vue';
import NextBtn from './components/NextBtn.vue';
import PrevBtn from './components/PrevBtn.vue';
import Heading from './components/Heading.vue';
import TitleDesc from './components/TitleDesc.vue';
import DonationInfo from './components/DonationInfo.vue';
import DonationInfo2 from './components/style-two/DonationInfo.vue';
import DonationInfo3 from './components/style-three/DonationInfo.vue';
import DonationInfo5 from './components/style-five/DonationInfo.vue';
import DonationForm from './components/DonationForm.vue';
import DonationForm2 from './components/style-two/DonationForm.vue';
import DonationForm3 from './components/style-three/DonationForm.vue';
import DonationForm5 from './components/style-five/DonationForm.vue';
import PaymentGateways from './components/Gateways.vue';
import PaymentGateways2 from './components/style-two/Gateways.vue';
import PaymentGateways3 from './components/style-three/Gateways.vue';
import PaymentGateways5 from './components/style-five/Gateways.vue';
import BillingInfo from './components/BillingInfo.vue';
import BillingInfo2 from './components/style-two/BillingInfo.vue';
import BillingInfo5 from './components/style-five/BillingInfo.vue';
import ProductDonationInfo from './components/ProductDonationInfo.vue';
import ElementPlus from 'element-plus'

// window.$ = jQuery
const jQuery = window?.jQuery;
const pinia = createPinia();

const elem = document.querySelectorAll(".lifeline-donation-app");
if(elem) {
  elem.forEach(element => {
    const app = createApp({})  
    // app.use(i18n);
    app.use(ElementPlus, {
      locale: ElementPlusEn,
    })
    app.use(pinia);
    // app.component('index', Index);
    app.component('lifeline-donation-button', Button);
    app.component('lifeline-donation-modal', Modal);
    app.component('recurring-cycle', RecurringCycle);
    app.component('lifeline-donation-page-template', PageTemplate);
    app.component('lifeline-donation-heading', Heading);
    app.component('lifeline-donation-box-title', TitleDesc);
    app.component('lifeline-donation-amount-box', AmountBox);
    app.component('lifeline-donation-predefined-amounts', require('./components/PreDefinedAmounts.vue').default);
    app.component('lifeline-donation-proceed-btn', ProceedBtn);
    app.component('lifeline-donation-next-btn', NextBtn);
    app.component('lifeline-donation-back-btn', PrevBtn);
    app.component('lifeline-donation-info', DonationInfo);
    app.component('lifeline-donation-info2', DonationInfo2);
    app.component('lifeline-donation-info5', DonationInfo5);
    app.component('lifeline-donation-info3', DonationInfo3);
    app.component('lifeline-donation-form', DonationForm);
    app.component('lifeline-donation-form2', DonationForm2);
    app.component('lifeline-donation-form3', DonationForm3);
    app.component('lifeline-donation-form5', DonationForm5);
    app.component('lifeline-donation-gateways', PaymentGateways);
    app.component('lifeline-donation-gateways2', PaymentGateways2);
    app.component('lifeline-donation-gateways3', PaymentGateways3);
    app.component('lifeline-donation-gateways5', PaymentGateways5);
    app.component('lifeline-donation-billing-form', BillingInfo);
    app.component('lifeline-donation-billing-form2', BillingInfo2); 
    app.component('lifeline-donation-billing-form5', BillingInfo5);
    app.component('lifeline-donation-product-info', ProductDonationInfo);
    app.provide('store', useDonationFormsStore);
    jQuery(document).trigger('webinane-commerce-checkout-form-loaded', {app});
    app.mount(element);
    // console.log('app', app);
  });
}




// const { __, setLocaleData } = wp.i18n
// Vue.config.devtools = true
// const Vuex = window.Vuex;
// import Modal from './components/Modal.vue';
// import PageTemplate from './components/PageTemplate.vue';
// import Button from './components/Button.vue';
// import AmountBox from './components/AmountBox.vue';
// import ProceedBtn from './components/ProceedBtn.vue';
// import NextBtn from './components/NextBtn.vue';
// import PrevBtn from './components/PrevBtn.vue';
// import Heading from './components/Heading.vue';
// import TitleDesc from './components/TitleDesc.vue';
// import DonationInfo from './components/DonationInfo.vue';
// import DonationInfo2 from './components/style-two/DonationInfo.vue';
// import DonationInfo3 from './components/style-three/DonationInfo.vue';
// import DonationInfo5 from './components/style-five/DonationInfo.vue';
// import DonationForm from './components/DonationForm.vue';
// import DonationForm2 from './components/style-two/DonationForm.vue';
// import DonationForm3 from './components/style-three/DonationForm.vue';
// import DonationForm5 from './components/style-five/DonationForm.vue';
// import PaymentGateways from './components/Gateways.vue';
// import PaymentGateways2 from './components/style-two/Gateways.vue';
// import PaymentGateways3 from './components/style-three/Gateways.vue';
// import PaymentGateways5 from './components/style-five/Gateways.vue';
// import BillingInfo from './components/BillingInfo.vue';
// import BillingInfo2 from './components/style-two/BillingInfo.vue';
// import BillingInfo5 from './components/style-five/BillingInfo.vue';

// import store from './store'
// import donation_mixin from './mixin'

// ELEMENT.locale(ELEMENT.lang.en)
// Vue.use(ELEMENT)


// Vue.component('lifeline-donation-button', Button);
// Vue.component('lifeline-donation-modal', Modal);
// Vue.component('lifeline-donation-page-template', PageTemplate);

// // Components
// Vue.component('lifeline-donation-heading', Heading);
// Vue.component('lifeline-donation-box-title', TitleDesc);
// Vue.component('lifeline-donation-amount-box', AmountBox);
// Vue.component('lifeline-donation-predefined-amounts', require('./components/PreDefinedAmounts.vue').default);
// Vue.component('lifeline-donation-proceed-btn', ProceedBtn);
// Vue.component('lifeline-donation-next-btn', NextBtn);
// Vue.component('lifeline-donation-back-btn', PrevBtn);
// Vue.component('lifeline-donation-info', DonationInfo);
// Vue.component('lifeline-donation-info2', DonationInfo2);
// Vue.component('lifeline-donation-info5', DonationInfo5);
// Vue.component('lifeline-donation-info3', DonationInfo3);
// Vue.component('lifeline-donation-form', DonationForm);
// Vue.component('lifeline-donation-form2', DonationForm2);
// Vue.component('lifeline-donation-form3', DonationForm3);
// Vue.component('lifeline-donation-form5', DonationForm5);
// Vue.component('lifeline-donation-gateways', PaymentGateways);
// Vue.component('lifeline-donation-gateways2', PaymentGateways2);
// Vue.component('lifeline-donation-gateways3', PaymentGateways3);
// Vue.component('lifeline-donation-gateways5', PaymentGateways5);
// Vue.component('lifeline-donation-billing-form', BillingInfo);
// Vue.component('lifeline-donation-billing-form2', BillingInfo2); 
// Vue.component('lifeline-donation-billing-form5', BillingInfo5); 

// lifeline_donation.eventBus = new Vue()


// const elem = document.querySelectorAll(".lifeline-donation-app");
// if(elem) {
//   elem.forEach(element => {
//     const app = new Vue({
//       el: element,
//       store,
//     });
//   });
// }

// jQuery(document).trigger('webinane-commerce-checkout-form-loaded')



